/**
 * Settings store times of day as decimal hours (9 = 09:00, 9.5 = 09:30, 17.75 = 17:45).
 * These helpers convert between that representation and the `HH:mm` strings used by
 * `<input type="time">`.
 */

/** Formats a decimal hour as `HH:mm`, returning `fallback` for missing/out-of-range values. */
export function formatHourAsTime(hour: number | undefined | null, fallback: string): string {
  if (hour == null || !Number.isFinite(hour) || hour < 0 || hour > 24) return fallback;
  const totalMinutes = Math.round(hour * 60);
  const h = Math.floor(totalMinutes / 60) % 24;
  const m = totalMinutes % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

/** Returns a copy of `date` set to the given decimal hour of day, keeping its minutes. */
export function atHourOfDay(date: Date, hour: number): Date {
  const result = new Date(date);
  const totalMinutes = Math.round(hour * 60);
  result.setHours(Math.floor(totalMinutes / 60), totalMinutes % 60, 0, 0);
  return result;
}

/** Parses an `HH:mm` string into a decimal hour, or null when it is not a valid time of day. */
export function parseTimeToHour(value: string): number | null {
  const match = /^(\d{1,2}):(\d{2})/.exec(value.trim());
  if (!match) return null;
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return null;
  return hours + minutes / 60;
}
